import {Model} from "@vuex-orm/core";
import BeneficiaryAssignment from "./BeneficiaryAssignment";

export default class Property extends Model{
    /* Follow the namespace in the backend */
    static entity = 'Household\\Model\\Property';

    static STYLE_PRIMARY = 0;
    static STYLE_RENTAL = 1;
    static STYLE_BUSINESS_COMMERCIAL = 2;
    static STYLE_VACATION = 3;

    static STYLE_LABELS = {
        [Property.STYLE_PRIMARY]: 'Primary',
        [Property.STYLE_RENTAL]: 'Rental',
        [Property.STYLE_BUSINESS_COMMERCIAL]: 'Business/Commercial',
        [Property.STYLE_VACATION]: 'Vacation',
    }


    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            account_number: this.attr(null),
            household_id: this.number(0),
            value: this.number(null),
            mortgage: this.number(0),
            style_cd: this.attr(''),
            payment: this.number(''),
            income: this.number(''),
            beneficiaryAssignments: this.morphMany(BeneficiaryAssignment, 'assignable_id', 'assignable_type'),
        }
    }

    get styleLabel() {
        return Property.STYLE_LABELS[this.style_cd];
    }

    get accountsOverviewName() {
        return this.account_number ?? this.name ?? 'n/a'
    }

    get accountsOverviewValue() {
        return parseFloat(this.mortgage);
    }
}
